import { ConfigData } from 'types/interfaces';

const config: ConfigData = {
  ID: 'DOCUMENTS_STEP',
  SUB_STEP_IDS: ['ESIGN_CONFIRM_STEP', 'SAFEID_STEP', 'IDENTITY_CHECK_STEP_TWO'],
  SIDEBAR_MENU: true,
  PROGRESS_BAR: true,
  PROGRESS_BAR_COUNT: true,
  FOOTER: true,
  BUTTON_HELP: true,
  BUTTON_LANG: true,
  BUTTON_QUIT: true,
};

export default config;
